import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RESET_PASSWORD_OTP_UPDATE } from '../../features/auth/authSlice';
import { sendOtpAgain } from '../../api/auth';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ForgotPasswordOtp = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const authState = useSelector(state => state.auth);
    const [ timeOut, setTimeOut ] = useState(30);

    const [otp, setOtp] = useState('');
    const [otpError, setOtpError] = useState('');

    const validateOtp = (otp) => {
        const otpRegex = /^[0-9]{4}$/;
        return otpRegex.test(otp);
    };    

    const handleSendAgain = e => {
        e.preventDefault();
        sendOtpAgain({ email: authState.email }, dispatch, toast);
        setTimeOut(30);
    }
    
    const handleSubmit = (e) => {
        e.preventDefault();
        setOtpError('');

        let isValid = true;
        // Otp validation
        if (otp === '') {
            setOtpError('OTP is required.');
            isValid = false;
        } else if(!validateOtp(otp)){
            setOtpError('Please enter a valid OTP.');
            isValid = false;
        }

        if (isValid) {
            dispatch(RESET_PASSWORD_OTP_UPDATE(otp));
            navigate('/resetpassword');
        }
    };

    useEffect(() => {
        if (timeOut > 0) {
            const timer = setTimeout(() => {
                setTimeOut((prev) => prev - 1);
            }, 1000);

            return () => clearTimeout(timer); // Cleanup the timeout
        }
    }, [timeOut]);
    
    return (
        <div className='w-screen h-screen flex justify-between items-center p-5 gap-5'>
            <div className='h-full basis-1/2 rounded-3xl py-5 flex flex-col items-center bg-[radial-gradient(_109.97%_217.38%_at_0%_0%,_#f2fff7_0%,_#a1fbc0_68.68%,_#81f7a9_100%_)]'>
                <div className='place-self-start flex justify-start items-center'>
                    <img src={require('../../utils/media/logo.png')} alt="climate crusaders" className='h-16' />
                    <h1 className='text-primary font-extrabold text-lg'>Climate Crusaders</h1>
                </div>
                <div className='h-full flex justify-center items-center'>
                    <img src={require('../../utils/media/login_page.png')} className='place-self-center' alt="" />
                </div>
            </div>
            <div className='rounded-3xl shadow-lg basis-1/2 flex flex-col justify-start items-center py-20 px-14'>
                <h1 className='text-primary text-4xl font-semibold'>Verification Code Sent!</h1>
                <form action="" method='post' className='w-full my-10 flex flex-col'>
                    <div className="email flex flex-col w-full">
                        <span className={`${otpError ? 'text-red' : 'text-black'} font-bold text-base`}>Otp</span>
                        <input
                            type="text"
                            name="otp"
                            id="otp"
                            required
                            placeholder='Enter OTP'
                            className={`border ${otpError ? 'border-red' : 'border-secondary'} rounded-md px-3 py-2 outline-primary`}
                            value={otp}
                            onChange={e => {
                                const value = e.target.value;
                                if (/^\d{0,4}$/.test(value)) {
                                    setOtp(value);
                                }
                            }}
                            maxLength="4"
                        />
                        {
                            otpError &&
                            <p className={`${otpError ? 'text-red' : 'text-black'} inline text-base`}>
                                {otpError}
                            </p>
                        }
                    </div>
                    {/* <button className='text-primary mt-6 underline text-right' onClick={handleSendAgain}>
                        {timeOut} Resend Verification Code
                    </button> */}
                    <button
                        className={`text-primary mt-6 underline text-right text-base ${timeOut > 0 ? 'cursor-not-allowed opacity-50' : ''}`}
                        onClick={handleSendAgain}
                        disabled={timeOut > 0}
                    >
                        {timeOut > 0 ? `Resend OTP After ${timeOut} Seconds` : 'Resend Verification Code'}
                    </button>
                    <button className='bg-primary self-end text-base px-10 min-w-52 max-w-80 py-2 text-white font-bold mt-10 rounded-md border hover:bg-white hover:border hover:text-primary' onClick={handleSubmit}>
                        Submit
                    </button>
                </form>
            </div>
            <ToastContainer 
                position = "bottom-right"
            />
        </div>
    )
}

export default ForgotPasswordOtp;